// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2axzp","content":"GlobalSearch_content__3R1w6"};